import React from 'react';

const ArrowUp: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...props }) => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="64" height="64" fill="#20252A" />
      <path
        d="M47.9983 39.999C47.9358 44.2013 46.2226 48.2104 43.2289 51.16C40.2351 54.1096 36.2011 55.763 31.9983 55.763C27.7956 55.763 23.7615 54.1096 20.7677 51.16C17.7739 48.2104 16.0608 44.2013 15.9983 39.999H19.9979C20.0519 43.1461 21.34 46.1461 23.5846 48.3525C25.8292 50.5589 28.8508 51.7952 31.9983 51.7952C35.1458 51.7952 38.1673 50.5589 40.412 48.3525C42.6566 46.1461 43.9447 43.1461 43.9987 39.999"
        fill="#00A868"
      />
      <path
        d="M47.9981 9.96533H43.9985V39.9992H47.9981V9.96533Z"
        fill="#00A868"
      />
      <path
        d="M47.4346 11.3877L44.6064 8.55957L36.5821 16.5839L39.4102 19.412L47.4346 11.3877Z"
        fill="#00A868"
      />
      <path
        d="M52.6428 19.4277L55.4709 16.5996L47.4467 8.5754L44.6186 11.4035L52.6428 19.4277Z"
        fill="#00A868"
      />
      <path
        d="M46.0001 11.9986C47.1056 11.9986 48.0017 11.1026 48.0017 9.99721C48.0017 8.89178 47.1056 7.99561 46.0001 7.99561C44.8947 7.99561 43.9985 8.89178 43.9985 9.99721C43.9985 11.1026 44.8947 11.9986 46.0001 11.9986Z"
        fill="#00A868"
      />
      <path
        d="M53.9993 20.0013C55.1047 20.0013 56.0009 19.1051 56.0009 17.9996C56.0009 16.8942 55.1047 15.998 53.9993 15.998C52.8939 15.998 51.9978 16.8942 51.9978 17.9996C51.9978 19.1051 52.8939 20.0013 53.9993 20.0013Z"
        fill="#00A868"
      />
      <path
        d="M37.9976 20.0013C39.103 20.0013 39.9992 19.1051 39.9992 17.9996C39.9992 16.8942 39.103 15.998 37.9976 15.998C36.8922 15.998 35.9961 16.8942 35.9961 17.9996C35.9961 19.1051 36.8922 20.0013 37.9976 20.0013Z"
        fill="#00A868"
      />
      <path
        d="M17.9998 39.9991C19.1052 39.9991 20.0014 39.1029 20.0014 37.9975C20.0014 36.8921 19.1052 35.9961 17.9998 35.9961C16.8944 35.9961 15.9983 36.8921 15.9983 37.9975C15.9983 39.1029 16.8944 39.9991 17.9998 39.9991Z"
        fill="#00A868"
      />
      <path
        d="M19.9979 37.9976H15.9983V39.9992H19.9979V37.9976Z"
        fill="#00A868"
      />
    </svg>
  );
};

export default ArrowUp;
